import { useCallback } from 'react';
import { Alert, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuthorization } from 'framework/authorization';
import { EditFormShowButton } from 'framework/form';
import IconButton from '@mui/material/IconButton';
import { OverridableStringUnion } from '@mui/types';
import { AlertColor, AlertPropsColorOverrides } from '@mui/material/Alert/Alert';
import { useShowContext } from 'framework/show';
import {
  useProjectDataContext,
  ACCESS_INFO_ACTIONS,
  ACCESS_INFO_SECTIONS,
  useProjectSecurityContext,
  BUDGET_UPDATE,
  useNewProjectUrl,
  ProjectSectionAccordion,
} from 'domain/shared/newProject';

const EmptyBudgetComponent = ({
  alertType,
  alertText,
}: {
  alertType?: OverridableStringUnion<AlertColor, AlertPropsColorOverrides>;
  alertText?: string;
}) => {
  const { getUpdateBudgetUrl } = useNewProjectUrl();
  const navigate = useNavigate();
  const { isGranted } = useAuthorization();
  const { data: projectData } = useProjectDataContext();
  const { isAccessGranted } = useProjectSecurityContext();

  const { data } = useShowContext();

  const renderActions = useCallback(() => {
    if (
      (!isGranted(BUDGET_UPDATE) && !isAccessGranted(ACCESS_INFO_SECTIONS.BUDGET, ACCESS_INFO_ACTIONS.MANAGE)) ||
      !data?.result
    ) {
      return [];
    }
    return [
      <IconButton sx={{ p: 0, ml: 1 }} key="add" onClick={() => navigate(getUpdateBudgetUrl(projectData.id!))}>
        <EditFormShowButton />
      </IconButton>,
    ];
  }, [data?.result, getUpdateBudgetUrl, projectData, isGranted, isAccessGranted, navigate]);

  return (
    <ProjectSectionAccordion
      defaultExpanded
      title={
        <Stack direction="row" sx={{ justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
          <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
            <Typography variant="h4" color="primary" pl={2}>
              Budget
            </Typography>
          </Stack>
          <>{renderActions()}</>
        </Stack>
      }
    >
      <Alert severity={alertType}>{alertText}</Alert>
    </ProjectSectionAccordion>
  );
};

export default EmptyBudgetComponent;
